import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import * as s from '../fp-ts/string';
export var stringFromNumber = new t.Type('StringFromNumber', t.string.is, function (u, c) { return pipe(t.number.validate(u, c), E.map(s.fromNumber)); }, Number);
